export default __webpack_public_path__ + "static/media/hbs-k-bpk-1.924aed6a.png";